<template>
  <div class="custom-select w-100" ref="customSelect">
    <div @click="toggleDropdown" class="select-header" :disabled="disable">
      <template v-if="selectedValues.length">
        <div class="d-flex align-items-center flex-wrap">
          <span v-for="item in displayedOptions" :key="item.id"
            class="py-1 px-2 selected-item d-flex align-items-center" :style="{
              backgroundColor: item.color ? item.color : '#f4f5f5',
              color: item.color ? '#fff' : '#909399',
            }" style="font-size: 10px; border-radius: 4px">
            <span>{{ item.value }}</span>
            <div class="ms-1" style="margin-top: 2px" @click.stop="removeOption(item.value)">
              <IconFont size="12px" name="el-icon-close" />
            </div>
          </span>
          <span class="px-2" v-if="selectedOptions.length > 3"
            style="background: #f5f5f5; font-size: 10px; border-radius: 4px">
            +{{ hiddenOptions.length }}
          </span>
        </div>
      </template>
      <span v-else ref="placeHolder" :style="{
        display: isOpen ? 'none' : 'block',
        fontSize: '13px',
        fontWeight: 400,
        color: '#b9bec6f3'
      }">
        {{ placeholder }}
      </span>

      <input v-if="isOpen" v-model="searchText" ref="filterInput" class="filter-input" />
      <i class="arrow" :class="{ open: isOpen }"></i>
    </div>

    <ul :class="{
      'select-dropdown w-100 open': isOpen,
      'select-dropdown w-100': !isOpen,
    }">
      <li style="position: relative; z-index: 99999" v-for="option in visibleOptions" :key="option.id"
        @click.stop="toggleOption(option)" :class="{ selected: selectedValues.includes(option.id) }">
        <div style="min-width: 16px; margin-right: 8px">
          <input class="checkbox d-flex" type="checkbox" :id="'option-' + option.id" :value="option.value"
            v-model="selectedValues" @change="emitChange" />
        </div>
        <span class="w-100 d-flex align-items-center" :for="'option-' + option.id">
          <span class="option-label" :style="{
            backgroundColor: option.color ? option.color : '#909399',
          }">{{ option.value }}</span>
        </span>
        <div class="material-icons" style="font-size: 16px; cursor: pointer; color: #327ae7"
          @click.stop="toggleVisibility(option)">
          visibility
        </div>
      </li>
      <li v-if="isVisible && !showAll" style="position: relative; z-index: 99999" @click="displayAll()">
        <span class="option-label" style="color: #000">Hiển thị các trường đã ẩn</span>
      </li>
      <div v-if="showAll">
        <li class="d-flex align-items-center justify-content-between" v-for="(option, index) in visibleOffOptions"
          :key="index" :class="{ selected: selectedValues.includes(option.id) }" style="cursor: no-drop;">
          <div style="cursor: no-drop;min-width: 16px; margin-right: 8px">
            <input class="checkbox d-flex" type="checkbox" :id="'option-' + option.id" :value="option.value"
              style="cursor: no-drop;" />
          </div>
          <span class="w-100 d-flex align-items-center" :for="'option-' + option.id">
            <span class="option-label" :style="{
              backgroundColor: option.color ? option.color : '#909399',
            }">{{ option.value }}</span>
          </span>
          <div class="material-icons" style="font-size: 16px; cursor: pointer" @click.stop="toggleVisibility(option)">
            visibility
          </div>
        </li>
        <li style="position: relative; z-index: 99999" @click="collapse()">
          <span class="option-label" style="color: #000">Thu gọn</span>
        </li>
      </div>
    </ul>
  </div>
</template>


<script>
import IconFont from "./IconFont.vue";
export default {
  name: "MultiSelectCustom",
  components: { IconFont },
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Array],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "Chọn các tùy chọn",
    },
    disable: {
      type: Boolean,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    companyCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedValues: Array.isArray(this.value) ? [...this.value] : [],
      hiddenOptionsIds: this.getStoredHiddenOptions(),
      isVisible: this.getStoredIsVisible(),
      showAll: false,
      searchText: '',
    };
  },
  computed: {
    visibleOptions() {
      if (!this.searchText) return this.options.filter(
        (option) => !this.hiddenOptionsIds.includes(option.id)
      );
      return this.options.filter(
        (option) => !this.hiddenOptionsIds.includes(option.id) && option.value.trim().toLowerCase().includes(this.searchText.trim().toLowerCase())
      );
    },
    visibleOffOptions() {
      return this.options.filter((option) =>
        this.hiddenOptionsIds.includes(option.id)
      );
    },
    selectedOptions() {
      return this.options.filter((option) =>
        this.selectedValues.includes(option.value)
      );
    },
    displayedOptions() {
      return this.selectedOptions.slice(0, 3);
    },
    hiddenOptions() {
      return this.selectedOptions.slice(3);
    },
  },
  methods: {
    getStoredHiddenOptions() {
      const stored = JSON.parse(localStorage.getItem("hiddenOptions") || "{}");
      return (
        (stored &&
          stored[this.companyCode] &&
          stored[this.companyCode][this.code]) ||
        []
      );
    },
    getStoredIsVisible() {
      const stored = JSON.parse(localStorage.getItem("isVisible") || "{}");
      return (
        (stored &&
          stored[this.companyCode] &&
          stored[this.companyCode][this.code]) ||
        false
      );
    },
    saveHiddenOptions() {
      const stored = JSON.parse(localStorage.getItem("hiddenOptions") || "{}");
      if (!stored[this.companyCode]) {
        stored[this.companyCode] = {};
      }
      stored[this.companyCode][this.code] = this.hiddenOptionsIds;
      localStorage.setItem("hiddenOptions", JSON.stringify(stored));
    },
    saveIsVisible() {
      const stored = JSON.parse(localStorage.getItem("isVisible") || "{}");
      if (!stored[this.companyCode]) {
        stored[this.companyCode] = {};
      }
      stored[this.companyCode][this.code] = this.isVisible;
      localStorage.setItem("isVisible", JSON.stringify(stored));
    },
    displayAll() {
      // this.isVisible = false;
      // this.hiddenOptionsIds = [];
      this.showAll = true;
      this.saveHiddenOptions();
      this.saveIsVisible();
      document.removeEventListener("click", this.handleClickOutside);

      this.isOpen = true;
      setTimeout(() => {
        document.addEventListener("click", this.handleClickOutside);
      }, 200);
    },
    collapse() {
      this.showAll = false;
      document.removeEventListener("click", this.handleClickOutside);

      this.isOpen = true;
      setTimeout(() => {
        document.addEventListener("click", this.handleClickOutside);
      }, 200);
    },
    toggleVisibility(option) {
      if (this.hiddenOptionsIds.includes(option.id)) {
        this.hiddenOptionsIds = this.hiddenOptionsIds.filter(
          (id) => id !== option.id
        );
      } else {
        this.hiddenOptionsIds.push(option.id);
      }

      if (this.hiddenOptionsIds.length == 0) {
        this.showAll = false;
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
      this.saveHiddenOptions();
      this.saveIsVisible();
      // this.removeOption(option.value);
    },
    toggleDropdown() {
      if (this.disable) return;
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          this.$refs?.filterInput?.focus();
        });
      }
    },
    toggleOption(option) {
      if (this.disable) return;
      const index = this.selectedValues.indexOf(option.value);
      if (index === -1) {
        this.selectedValues.push(option.value);
      } else {
        this.selectedValues.splice(index, 1);
      }
      if (this.isOpen) {
        this.$nextTick(() => {
          this.$refs?.filterInput?.focus();
        });
      }
      this.searchText = '';
      this.emitChange();
    },
    removeOption(value) {
      if (this.disable) return;
      const index = this.selectedValues.indexOf(value);
      if (index !== -1) {
        this.selectedValues.splice(index, 1);
        this.emitChange();
      }
    },
    onChange(value) {
      if (this.disable) return;
      this.toggleOption(this.options.find((option) => option.value === value));
    },
    emitChange() {
      this.$emit("input", [...this.selectedValues]);
      this.$emit("change", [...this.selectedValues]);
    },
    handleClickOutside(event) {
      if (!this.$refs?.customSelect.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  watch: {
    value(newVal) {
      this.selectedValues = [...newVal];
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.custom-select {
  position: relative;
  cursor: pointer;
  height: 32px;
}

.select-header {
  height: 32px;
  border: 1px solid #dcdfe6;
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.select-header[disabled] {
  background: #f5f7fa;
  cursor: not-allowed;
  color: #c0c4cc;
}

.selected-item {
  border-radius: 4px;
  font-size: 12px;
  margin-right: 4px;
  border: 1px solid #dcdfe6;
}

.selected-item span {
  max-width: 80px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.select-dropdown {
  position: absolute;
  width: 100%;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-top: 4px;
  z-index: 10;
  list-style: none;
  padding: 0;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-height 0.3s ease-in-out, opacity 0.2s ease-in-out;
}

.select-dropdown.open {
  overflow-y: scroll;
  max-height: 150px;
  opacity: 1;
}

.select-dropdown li {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  transition: background 0.2s;
}

.select-dropdown li span {
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
}

.select-dropdown li:hover {
  background: #f5f7fa;
}

.select-dropdown li.selected {
  background: #e6f7ff;
}

.option-label {
  border-radius: 4px;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
  padding: 4px 8px;
}

.arrow {
  position: relative;
  top: -2px;
  right: 4px;
  border: solid #dcdfe6;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  transition: transform 0.2s;
}

.arrow.open {
  transform: rotate(-135deg);
  top: 2px;
}

.checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  background-color: white;
  transition: background-color 0.3s, border-color 0.3s;
}

.checkbox:checked::before {
  content: "";
  position: absolute;
  top: 12%;
  left: 30%;
  width: 5px;
  height: 9px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox:hover {
  border-color: #1769d7;
}

.checkbox:checked {
  background-color: #1769d7;
}

.filter-input {
  border: none;
  outline: none;
  font-size: 13px;
  background: transparent;
  padding: 0 4px;
  min-width: 60px;
  flex: 1;
}
</style>
